import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const EurostatSection = () => {
  return (
    <section id="eurostat" className="py-20 bg-paper-200 border-y border-paper-300">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div>
            <p className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-3">
              Eurostat methodology
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-ink tracking-tight mb-3">
              Aligning with the Eurostat reference pipeline
            </h2>
            <p className="text-base md:text-lg text-ink-muted leading-relaxed">
              Eurostat publishes a reference pipeline for producing official
              statistics from mobile network data. We are building our
              processing to follow it, so statistical offices can check our
              outputs against a method they already know. We are in active
              dialogue with national statistical institutes in the markets we
              serve.
            </p>
          </div>

          <div className="mt-10 flex justify-center">
            <div className="w-full max-w-2xl bg-paper border border-paper-300 rounded-xl px-8 py-7 text-left">
              <p className="text-xs font-semibold tracking-widest text-ink-subtle uppercase mb-2">
                Reference
              </p>
              <p className="font-display text-lg font-semibold text-ink mb-1">
                Eurostat MultiMNO reference pipeline
              </p>
              <p className="text-sm text-ink-muted leading-relaxed mb-4">
                Eurostat's open-source reference code and documentation for
                producing population and mobility statistics from mobile network
                operator data.
              </p>
              <a
                href="https://eurostat.github.io/multimno/latest/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-600 hover:text-brand-700 underline underline-offset-2"
              >
                Read the Eurostat documentation <ExternalLink size={14} aria-hidden="true" />
              </a>
            </div>
          </div>

          <p className="mt-6 text-sm text-ink-subtle">
            How outputs are anonymised is covered in{" "}
            <Link
              to="/platform/privacy"
              className="font-medium text-brand-600 underline underline-offset-2 hover:text-brand-700"
            >
              Privacy architecture
            </Link>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default EurostatSection;
